import React, { useEffect } from "react"
import { useTranslation } from 'react-i18next'

function Logout() {
  useEffect(() => {
    localStorage.clear()            
  })

  const { t } = useTranslation();
  return <div className="text-align-center">{t("Logout")}</div>;

}

export default Logout;